'use client';
import React, { useState, useEffect } from 'react';
import { SvgInfo, SvgCheck } from '../formSvg/formSvg';
import { Tooltip } from 'react-tooltip';
import { emailUnsubscribe } from '@/app/api/emailUnsubscribe/emailUnsubscribe';

export default function ShortForm() {
  const [errorMessagesShort, setErrorMessagesShort] = useState({
    emailShort: false
  });
  const [readyToSubmitShort, setReadyToSubmitShort] = useState(false);
  const [shortFeedback, setShortFeedback] = useState('');
  const [feedbackStatus, setFeedbackStatus] = useState('');
  const [isMounted, setIsMounted] = useState(false);
  const [shortFormValues, setShortFormValues] = useState({ email: '' });
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleChangeShort = (event) => {
    const { value } = event.target;
    setShortFormValues({ email: value });
  };

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const validateShort = () => {
    let tempObj = errorMessagesShort;
    let errors = 0;

    if (
      shortFormValues.email === '' ||
      !emailRegex.test(shortFormValues.email)
    ) {
      tempObj = { ...tempObj, emailShort: true };
      errors = 1;
    }

    setReadyToSubmitShort(!errors);
    setErrorMessagesShort({ ...tempObj });

    return errors;
  };

  const focusOutValidateShort = (name) => {
    let tempObj = errorMessagesShort;
    let error = false;

    if (name === 'emailShort') {
      if (shortFormValues.email === '') {
        tempObj = { ...errorMessagesShort, emailShort: true };
        error = true;
      } else if (!emailRegex.test(shortFormValues.email)) {
        tempObj = { ...errorMessagesShort, emailShort: true };
        error = true;
      } else {
        tempObj = { ...errorMessagesShort, emailShort: false };
      }
    }

    setReadyToSubmitShort(!error);
    setErrorMessagesShort({ ...tempObj });
  };

  const unSubscribeCustomerShort = async (event) => {
    event.preventDefault();
    setShortFormValues({ email: event.target.emailShort.value });
    const errorsFound = validateShort(shortFormValues);

    if (errorsFound == 0) {
      try {
        const unsubscribe = await emailUnsubscribe(shortFormValues.email);
        if (unsubscribe.success) {
          setShortFormValues({ email: '' });
          setReadyToSubmitShort(false);
          setShortFeedback(
            'Your email has been successfully suppressed from our email marketing'
          );
          setFeedbackStatus('success');
        } else {
          setShortFeedback(
            `Error: ${unsubscribe.data.error || 'Something went wrong'}`
          );
          setFeedbackStatus('error');
        }
      } catch (error) {
        console.error('Error during unsubscribe:', error);
        console.error('Something went wrong with your opt-out request');
        setShortFeedback('error');
        setFeedbackStatus('error');
      }
    }
  };

  return (
    <form
      onSubmit={unSubscribeCustomerShort}
      id="unsubscribe-form"
      className="mt-5 mb-4 bg-white px-8 pt-6 pb-[56px] shadow-md"
    >
      <div className="font-lato mx-auto flex w-full max-w-[400px] flex-col items-center lg:max-w-[600px]">
        <h3 className="p-10 text-center">
          Submit your email below to opt out of Leesa email marketing
        </h3>
        <div className="w-full lg:flex">
          <div className="w-full pb-2">
            <div className="relative">
              <label htmlFor="emailShort" className="form-label">
                Email
              </label>
              <div
                className="mx-1 inline-block h-4 w-4"
                data-for="opt-out-email"
                data-tooltip-id="opt-out-email"
                data-tip="opt-out-email"
              >
                <SvgInfo />
              </div>
              {isMounted && (
                <Tooltip
                  id="opt-out-email"
                  className="w-60"
                  place="top"
                  effect="solid"
                  textColor="white"
                  backgroundColor="black"
                >
                  Enter an email with the format of johnsmith@email.com
                </Tooltip>
              )}
            </div>
            <input
              type="email"
              id="emailShort"
              className="input border-parlor-green placeholder-parlor-green block w-full border bg-white px-[10px] py-2 focus:outline-none"
              name="emailShort"
              value={shortFormValues.email || ''}
              onChange={handleChangeShort}
              onBlur={(e) => focusOutValidateShort(e.target.name)}
            />
            <div className="text-error-red h-5 text-sm">
              {errorMessagesShort.emailShort ? 'Please add a valid email' : ''}
            </div>
          </div>
        </div>
        <button
          disabled={readyToSubmitShort ? false : true}
          type="submit"
          className={`btn btn-primary ${readyToSubmitShort ? '' : 'bg-grey-text!'}`}
        >
          Send Request
        </button>
        {shortFeedback && (
          <div className="container mx-auto mt-[28px] flex w-1/2 min-w-fit flex-col">
            <FormResponseShort
              feedback={shortFeedback}
              status={feedbackStatus}
            />
          </div>
        )}
      </div>
    </form>
  );
}

const FormResponseShort = ({ feedback }) => (
  <div className="rounded-md bg-green-50 p-4">
    <div className="flex">
      <div className="bg-green relative h-6 w-6 min-w-[24px] rounded-full">
        <SvgCheck />
      </div>
      <div className="ml-3 self-center">
        <p className="text-sm font-medium">{feedback}</p>
      </div>
    </div>
  </div>
);
